import { z } from 'zod';

export const MaintenanceState = z.object({
    enabled: z.boolean(),
    /** Set while the server is running its startup migrations (never persisted). */
    startup: z.boolean().optional(),
    /** Optional message shown to locked-out users instead of the generic default. */
    message: z.string().nullish(),
});
export type MaintenanceState = z.infer<typeof MaintenanceState>;
